<script>
import { PartyResource } from '@/resources/launcher.js'

export default {
    components: {},
    props: {
        party: {
            required: true,
            type: Object
        },
        editable: Boolean,
    },
    computed: {},
    watch: {},
    data() {
        return {
            partyName: this.party.attributes.name
        }
    },
    methods: {
        onClick() {
            if (!this.editable) {
                return false
            }

            this.$refs.partyEditModal.show()
        },
        async save() {
            this.party.attributes.name = this.partyName
            this.party.changes = { name: this.partyName }
            await this.party.save()
            this.$emit('update')
        }
    },
}
</script>

<template>
    <span>
        <b-component :is="(editable) ? 'b-link' : 'span'" @click="onClick()" class="party-name">{{ String(party) }}</b-component>
        <b-modal ref="partyEditModal" title="Party-Namen ändern" @ok="save()" ok-title="Party speichern" no-stacking no-close-on-backdrop scrollable centered no-fade>
            <b-form-group label="Party-Name">
                <b-form-input v-model="partyName" />
            </b-form-group>
        </b-modal>
    </span>
</template>

<style lang="scss" scoped>
// .party-name {
//     text-decoration: none;
//     border-bottom: 2px dotted currentColor;
// }
</style>
